module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/duplexify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = ../../../../duplexify/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module chunks = 4